import React, { useState } from 'react';
import { Modal, Backdrop, Fade, IconButton, Typography, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { QRCodeSVG } from 'qrcode.react';
import { useTranslation } from "react-i18next";

const Scan3DModal = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Modal
        aria-labelledby="3d-scan-modal-title"
        aria-describedby="3d-scan-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}>
        <Fade in={open}>
          <Box
            sx={{
              position: 'relative',
              backgroundColor: 'background.paper',
              boxShadow: 5,
              p: 4,
              borderRadius: 2,
              width: 500,
              maxWidth: '100%',
              overflowY: 'auto',
              m: 'auto',
              display: 'flex',
              flexDirection: 'column',
            }}>
            <IconButton
              aria-label={t('scan3d.a11y.close')}
              sx={{ position: 'absolute', right: 8, top: 8, color: 'grey.500' }}
              onClick={handleClose}>
              <CloseIcon />
            </IconButton>

            <div className="infoList--title">{ t("menu.scan3D") }</div>

            <Typography variant="body1" id="3d-scan-modal-description">
              { t('scan3d.intro') }
            </Typography>

            <Typography variant="body1" gutterBottom>
              { t('scan3d.installPrefix') }{' '}
              <a
                href="https://apps.apple.com/ru/app/var%D1%81%D1%82%D1%83%D0%B4%D0%B8%D1%8F/id6504860659"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#1976d2', wordBreak: 'break-word' }}>
                { t('scan3d.iosApp') }
              </a>{' '}
              { t('scan3d.installSuffix') }
            </Typography>

            <Box sx={{ textAlign: 'center', mt: 3, mb: 2 }}>
              <QRCodeSVG
                value="https://apps.apple.com/ru/app/var%D1%81%D1%82%D1%83%D0%B4%D0%B8%D1%8F/id6504860659"
                size={236}
              />
            </Box>

            <div className="infoList--title">{ t('scan3d.instructionTitle') }</div>
            <Typography variant="body1" sx={{ mb: 2 }}>
              { t('scan3d.instructionText') }
            </Typography>

            <div className="infoList--title">{ t('scan3d.importantTitle') }</div>
            <Typography variant="body1" component="div">
              <div>{ t('scan3d.reqLine1') }</div>
              <br/>
              <div>{ t('scan3d.supportedExamples') }</div>
              <ul>
                <li>{ t('scan3d.phones') }</li>
                <li>{ t('scan3d.ipadAir') }</li>
                <li>{ t('scan3d.ipad') }</li>
              </ul>
            </Typography>

            <button onClick={handleClose}>
              { t('scan3d.ok') }
            </button>
          </Box>
        </Fade>
      </Modal>

      <div className="bm-item menu-item" onClick={handleOpen}>
        { t("menu.scan3D") }
      </div>
    </>
  );
};

export default Scan3DModal;
